const URL_API = 'https://api.piktid.com/api';

// Initialize the tokenDictionary
let tokenDictionary = {
    access_token: localStorage.getItem('pikaccess_token'),
    refresh_token: localStorage.getItem('pikrefresh_token'),
    url_api: URL_API
};

// Function to store tokens in local storage
function storeTokens(accessToken, refreshToken) {
    localStorage.setItem('pikaccess_token', accessToken);
    localStorage.setItem('pikrefresh_token', refreshToken);
}

function usePassword(encoded) {
    return atob(encoded);
}


// Function to get stored tokens from local storage
function getTokens() {
    return {
        access_token: localStorage.getItem('pikaccess_token'),
        refresh_token: localStorage.getItem('pikrefresh_token')
    };
}

// Function to clear tokens from local storage
function clearTokens() {
    localStorage.removeItem('pikaccess_token');
    localStorage.removeItem('pikrefresh_token');
}

// Log process to the Rails backend
function sendProcessLog(processName, productId, customerSession, imageId, faceId, result, error, data = {}) {
    fetch('https://elegilog.onrender.com/shopify/process_logs', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            process_name: processName,
            product_id: productId,
            customer_session: customerSession,
            image_id: imageId,
            face_id: faceId,
            result: result,
            error: error,
            data: data
        })
    })
    .then(response => response.json())
    .then(data => console.log('Log sent successfully:', data))
    .catch(error => console.error('Error sending log:', error));
}

// Function to start the authentication process and retrieve access and refresh tokens
function startCall(email, password, productId, session) {
    return $.ajax({
        url: `${URL_API}/tokens`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", "Basic " + btoa(email + ":" + usePassword(password)));
        },
        success: function (response) {
            const { access_token, refresh_token } = response;
            storeTokens(access_token, refresh_token);
            sendProcessLog('Authentication', productId, session, null, null, 'Login successful', null, response);
            console.log('Login successful');
            return { access_token, refresh_token };
        },
        error: function (error) {
            console.error('Login failed:', error);
            sendProcessLog('Authentication', productId, session, null, null, null, 'Login failed', error);
        }
    });
}

// Function to refresh tokens using the refresh token
// Refresh tokens
function refreshCall(tokenDictionary, productId, session) {
    return $.ajax({
        url: `${tokenDictionary.url_api}/tokens`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Authorization", "Basic " + btoa('jonathan.enhult@remuscles.com' + ":" + usePassword("SmVncnVwcGVuYWkxIQ==")));
        },
        success: function (response) {
            const { access_token, refresh_token } = response;
            storeTokens(access_token, refresh_token);
            tokenDictionary['access_token'] = access_token;
            sendProcessLog('Token Refresh', productId, session, null, null, 'Tokens refreshed successfully', null, response);
            console.log('Tokens refreshed successfully');
            return { access_token, refresh_token };
        },
        error: function (error) {
            console.error('Token refresh failed:', error);
            sendProcessLog('Token Refresh', productId, session, null, null, null, 'Token refresh failed', error);
        }
    });
}

// Function to check if tokens are available in localStorage or fetch new ones
function checkTokens(email, password, productId, session) {
    const tokens = getTokens();
    if (!tokens.access_token || !tokens.refresh_token) {
        // console.log('No tokens found. Fetching new tokens...');
        return startCall(email, password, productId, session);
    } else {
        // console.log('Tokens found in local storage:', tokens);
        return Promise.resolve(tokens);  // Token exists in local storage
    }
}

// Function to upload the target image
async function uploadTargetImage(srcImg, hairFactor, tokenDictionary, productImgId, productId, session) {
    const TOKEN = tokenDictionary.access_token;
    const URL_API = tokenDictionary.url_api;
    const options = { flag_hair: hairFactor === 1 };
    const formData = new URLSearchParams();

    formData.append('url', srcImg);
    formData.append('options', JSON.stringify(options));

    function postImage() {
        return $.ajax({
            url: `${URL_API}/consistent_identities/upload_target`,
            method: 'POST',
            headers: { 'Authorization': `Bearer ${TOKEN}` },
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const { image_id, faces } = response;
                const { coordinates_list, selected_faces, number_of_faces } = faces;
                productImgId['imageAddress'] = image_id;
                productImgId['indicesInfo'] = coordinates_list;
                productImgId['selectedFacesList'] = selected_faces;
                productImgId['numberOfFaces'] = number_of_faces;
                sendProcessLog('Image Upload', productId, session, image_id, null, 'Image uploaded successfully', null, response);
                return response;
            },
            error: function (error) {
                console.error('Error uploading image:', error);
                sendProcessLog('Image Upload', productId, session, null, null, null, 'Image upload failed', error);
            }
        });
    }

    return postImage().catch(error => {
        if (error.status === 401) {
            console.log('Access token expired, refreshing...');
            return refreshCall(tokenDictionary, productId, session).then(newTokens => {
                tokenDictionary.access_token = newTokens.access_token;
                return postImage();
            });
        }
    });
}

// Function to update tokenDictionary by checking or fetching new tokens
async function updateTokenDictionary(email, password, tokenDictionary, productId, session) {
    try {
        const tokens = await checkTokens(email, password, productId, session);
        tokenDictionary.access_token = tokens.access_token;
        tokenDictionary.refresh_token = tokens.refresh_token;
        // console.log('Tokens updated:', tokenDictionary);
    } catch (error) {
        console.error('Error updating tokens:', error);
    }
}

async function uploadFaces(dataUrl, label, uplFace, tokenDictionary, productId, session, imageAddress) {
    const TOKEN = tokenDictionary.access_token;
    const URL_API = tokenDictionary.url_api;
    const formData = new URLSearchParams();
    formData.append('url', dataUrl);

    try {
        const response = await fetch(`${URL_API}/consistent_identities/upload_face`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${TOKEN}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData
        });
        const data = await response.json();
        if (data.identity_name) {
            uplFace[label] = data.identity_name;
            sendProcessLog('Face Upload', productId, session, imageAddress, label, 'Face uploaded successfully', null, data);
        } else {
            // Handle error if identity_name is missing
            const errorMessage = data.message || 'Face upload failed: identity name not found';
            console.error('Error uploading face:', errorMessage);
            sendProcessLog('Face Upload', productId, session, imageAddress, label, null, errorMessage, data);
        }
    } catch (error) {
        console.error('Error uploading face:', error);
        sendProcessLog('Face Upload', productId, session, imageAddress, label, null, 'Face upload failed', error);
    }
}

async function generationCall(imageAddress, idxFace, identityName, tokenDictionary, strength, productId, session) {
    const TOKEN = tokenDictionary.access_token;
    const URL_API = tokenDictionary.url_api;
    const data = {
        id_image: imageAddress,
        id_face: idxFace,
        identity_name: identityName,
        options: JSON.stringify({ flag_replace_and_download: true, prompt_strength: strength, watermark_url: 'https://cdn.shopify.com/s/files/1/0859/6681/5569/files/Previews.png' })
    };

    function postGeneration() {
        return $.ajax({
            url: `${URL_API}/consistent_identities/generate`,
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${TOKEN}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(data),
            success: function (response) {
                console.log('Generation process successful:', response);
                sendProcessLog('Face Generation', productId, session, imageAddress, idxFace, 'Generation successful', null, response);
                return response;
            },
            error: function (error) {
                console.error('Error in generation process:', error);
                sendProcessLog('Face Generation', productId, session, imageAddress, idxFace, null, 'Generation failed', error);
            }
        });
    }

    return postGeneration().catch(error => {
        if (error.status === 401) {
            console.log('Access token expired, refreshing...');
            return refreshCall(tokenDictionary, productId, session).then(newTokens => {
                tokenDictionary.access_token = newTokens.access_token;
                return postGeneration();
            });
        }
    });
}

function getNotificationByName(nameList, tokenDictionary) {
    const TOKEN = tokenDictionary.access_token;
    const URL_API = tokenDictionary.url_api;

    // Function to make the API call
    function fetchNotifications(token) {
        return $.ajax({
            url: `${URL_API}/consistent_identities/notification/read`,
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({ name_list: nameList })
        });
    }

    // Make the initial call and handle token expiration
    return fetchNotifications(TOKEN).catch(error => {
        if (error.status === 401) { // If token is expired
            console.log('Access token expired, refreshing...');
            return refreshCall(tokenDictionary).then(newTokens => {
                tokenDictionary.access_token = newTokens.access_token;
                return fetchNotifications(newTokens.access_token); // Retry with new token
            });
        }
    });
}

function deleteNotification(notificationId, tokenDictionary) {
    const TOKEN = tokenDictionary.access_token;
    const URL_API = tokenDictionary.url_api;

    // console.log(`Deleting notification with ID: ${notificationId}`);

    // Function to delete the notification
    function removeNotification(token) {
        return $.ajax({
            url: `${URL_API}/consistent_identities/notification/delete`,
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({ id: notificationId })
        });
    }

    // Make the initial delete request and handle token expiration
    return removeNotification(TOKEN).catch(error => {
        if (error.status === 401) { // If token is expired
            console.log('Access token expired, refreshing...');
            return refreshCall(tokenDictionary).then(newTokens => {
                tokenDictionary.access_token = newTokens.access_token;
                return removeNotification(newTokens.access_token); // Retry with new token
            });
        }
    });
}

async function handleNotificationsNewSwapDownload(imageId, tokenDictionary, count, productId, session) {
    let i = 0;
    while (i < 100) {
        i++;
        try {
            const notifications = await getNotificationByName('download', tokenDictionary);
            // console.log("notifications", notifications);
            const notificationsToRemove = notifications.notifications_list.filter(n => n.name === 'download' && n.data.id_image === imageId);

            if (notificationsToRemove.length > count) {
                await Promise.all(notificationsToRemove.map(n => deleteNotification(n.id, tokenDictionary)));
                sendProcessLog('Notification Handling', productId, session, imageId, null, 'Download completed', null, notificationsToRemove);
                return [true, { ...notificationsToRemove[count].data }];
            }
            
            if (i >= 100) {
                console.log('Timeout. Error in generating faces.');
                return [false, {}];
            }

            await new Promise(resolve => setTimeout(resolve, 3000));
        } catch (error) {
            console.error('Error handling notifications:', error);
            sendProcessLog('Notification Handling', productId, session, imageId, null, null, 'Notification handling failed', error);
            return [false, {}];
        }
    }
    return [false, {}];
}

function loadProgressBar(progressBar, startPercentage, endPercentage, speed, helpText) {
    const progressValue = progressBar.querySelector(".percentage");
    const innerCircle = progressBar.querySelector(".inner-circle");
    const helpTextElement = document.querySelector(".help-text"); // Select help text element

    let startValue = startPercentage; // Start from the given starting percentage

    // Reset the progress value and stop any previous intervals
    clearInterval(progressBar.progressInterval);

    // Set the inner circle color to white
    innerCircle.style.backgroundColor = 'white';

    // Set initial help text
    helpTextElement.textContent = helpText; 

    // Start the progress interval
    progressBar.progressInterval = setInterval(() => {
        startValue++;
        progressValue.textContent = `${startValue}%`;
        progressValue.style.color = '#56b582';  // Set progress text color

        // Set the progress with conic-gradient using #56b582 as the progress color and #6c6c6c as the background color
        progressBar.style.background = `conic-gradient(#56b582 ${startValue * 3.6}deg, #6c6c6c 0deg)`;

        // Update the help text dynamically based on progress
        if (startValue == 90) {
            helpTextElement.textContent = "Almost there! Just polishing the final result for you.";
        }

        // Stop the interval when we reach the target percentage
        if (startValue === endPercentage) {
            clearInterval(progressBar.progressInterval);
        }
    }, speed);
}

// Function to reset the progress bar to 0
function resetProgressBar(progressBar) {
    clearInterval(progressBar.progressInterval);
    const progressValue = progressBar.querySelector(".percentage");
    const helpTextElement = document.querySelector(".help-text"); // Select help text element
    progressBar.querySelector(".inner-circle").style.backgroundColor = "white"; // Reset to white
    progressBar.style.background = "#6c6c6c"; // Set background to light black
    progressValue.textContent = "0%"; // Reset percentage text
    progressValue.style.color = "black"; // Reset percentage text color
    helpTextElement.textContent = "Generating preview, please wait (The process can take 20-40 seconds)."; // Reset help text
}